import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getColdHours, deleteColdHour, selectHour} from "../../store/actions/coldHoursActions";
import {toggleModal} from "../../store/actions/toggleModalActions";
import Spinner from "../_common/Spinner";
import List from "../_common/List";
import ConfirmationModal from "../_common/ConfirmationModal";
import ColdHoursModal from "./ColdHoursModal";

const selector = state => {
    const { language, coldHours, modalState } = state;
    return {
        t: language.translator,
        pending: coldHours.pending,
        coldHours: coldHours.coldHours,
        selected: coldHours.selected.hour,
        modalState: modalState
    }
};
const ColdHoursManagement = () => {
    const { t, pending, coldHours, modalState, selected} = useSelector(selector);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getColdHours())
    }, []);

    const toggleDeleteColdHour = () => {
        dispatch(toggleModal(true, 'Delete Cold Hour'))
    }
    const toggleEditColdHour = () => {
        dispatch(toggleModal(true, 'Edit Cold Hour'))
    }
    const deleteColdHourMethod = (configId) => {
        dispatch(deleteColdHour(configId))
        dispatch(toggleModal(false, 'Delete Cold Hour'))
    }


    return (
        <div className={'hoursWrapper'}>
            <div className={'hoursList'}>
                <div className="hoursHeader">
                    <span>{t.gettext('Cold Hours')}</span>
                    <div className='addAlertRuleBtn'
                         onClick={() => dispatch(toggleModal(true, 'Add Cold Hour'))}
                    >
                        <span className='material-icons'>add</span>
                    </div>
                </div>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={coldHours}
                        scroll
                        columnsNames={[t.gettext('Name--item')]}
                        columns={['configName','','']}
                        columnsWidths={['90%','5%','5%']}
                        getItemsMethod={getColdHours}
                        selected={selected}
                        editColumn={2}
                        deleteColumn={3}
                        deleteMethod={toggleDeleteColdHour}
                        editMethod={toggleEditColdHour}
                        selectItemMethod={selectHour}
                    />
                }
            </div>
            {(modalState.flag && modalState.modal === 'Add Cold Hour') &&
                <ColdHoursModal />
            }
            {(modalState.flag && modalState.modal === 'Edit Cold Hour') &&
                <ColdHoursModal
                    edit
                />
            }
            {(modalState.flag && modalState.modal === 'Delete Cold Hour') &&
                <ConfirmationModal
                    text={t.gettext('Do you want to delete')}
                    deleteModal
                    closeMethod={() =>  dispatch(toggleModal(false, 'Delete Cold Hour'))}
                    confirmMethod={() => deleteColdHourMethod(selected.configId)}
                    confirmButtonText={t.gettext('Delete')}
                />
            }
        </div>
    )
}

export default ColdHoursManagement
